import React from "react";

import { makeStyles } from "@fluentui/react-components";

import { translate } from "@/utils/translations";

const useStyles = makeStyles({
  container: {
    backgroundColor: "white",
    border: "1px solid #e5e7eb",
    borderRadius: "8px",
    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
    overflow: "hidden",
    padding: "16px",
    position: "relative",
    width: "100%",
  },
  progressBackgorund: {
    background: "#E6E6E6",
    bottom: "0",
    height: "4px",
    position: "absolute",
    width: "100%",
  },
  progressBar: {
    bottom: "0",
    height: "4px",
    left: "0",
    overflow: "hidden",
    position: "absolute",
    width: "100%",
  },
  progressGlow: {
    animationName: {
      "0%": {
        opacity: "1",
        transform: "translateX(-25%)",
      },
      "10%": {
        opacity: "1",
      },
      "100%": {
        opacity: "1",
        transform: "translateX(-25%)",
      },
      "40%": {
        opacity: "1",
        transform: "translateX(125%)",
      },
      "50%": {
        opacity: "1",
        transform: "translateX(125%)",
      },
      "60%": {
        opacity: "1",
      },
      "90%": {
        opacity: "1",
        transform: "translateX(-25%)",
      },
    },
    background:
      "linear-gradient(90deg, transparent 0%, #2979FF 50%, transparent 100%)",
    boxShadow:
      "0 0 8px rgba(0, 120, 212, 0.6), 0 0 16px rgba(0, 120, 212, 0.3)",
    animationDuration: "1s",
    animationIterationCount: "infinite",
    animationTimingFunction: "ease-in-out",
    bottom: "0",
    filter: "blur(0.5px)",
    height: "4px",
    position: "absolute",
    width: "50%",
    zIndex: 1,
  },
  text: {
    color: "#374151",
    fontSize: "14px",
    fontWeight: "700",
  },
});

interface LoadingProps {
  text?: string;
}

const Loading: React.FC<LoadingProps> = ({ text }) => {
  const styles = useStyles();

  return (
    <div className={styles.container}>
      <div className={styles.text}>{translate(text || "Working...")}</div>

      <div className={styles.progressBar}>
        <div className={styles.progressGlow} />
        <div className={styles.progressBackgorund} />
      </div>
    </div>
  );
};

export default Loading;
